import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=5fb36790&scoped=true&"
import script from "./Home.vue?vue&type=script&setup=true&lang=js&"
export * from "./Home.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=5fb36790&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb36790",
  null
  
)

export default component.exports